import * as React from 'react';
import { VerbIcon } from 'source/app/presentation/Shared/RPGIcon/VerbIcons.tsx/VerbIcons';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import { IMappedMonumentalRecord } from '../../Helpers/MappedMonumentalRecord';

export function DisplayMonumentalIcons({
	mmRecords
}: {
	mmRecords?: IMappedMonumentalRecord[];
}) {
	if (!mmRecords) {
		return null;
	}

	return (
		<span>
			{mmRecords.map((mmRecord, index) => (
				<DisplayRecord mmRecord={mmRecord} key={index} />
			))}
		</span>
	);
}

function DisplayRecord({ mmRecord }: { mmRecord: IMappedMonumentalRecord }) {
	return (
		<span
			{...Style(`dwkc_monumentalIcon`, {
				marginLeft: `5px`,
				textShadow: `0px 0px 10px gold`,
				position: `relative`,
				top: `1px`,
				paddingLeft: `5px`
			})}
			data-tip={mmRecord.tooltip}
		>
			<VerbIcon verbSymbol={mmRecord.verbSymbol} color="gold" />
		</span>
	);
}
